module.exports = __webpack_public_path__ + "img/img4.18248b7e.svg";